import React, { useEffect } from "react";
import FloatingLogoAndButton from "../FloatingLogoAndButton/FloatingLogoAndButton";
import { Helmet } from "react-helmet-async";

// 📸 PODSTAW ZDJĘCIA
import imgMild from "../../assets/images/bydgoszcz/cigar/mild.jpg";
import imgOrigin from "../../assets/images/bydgoszcz/cigar/leaf-farm.jpg";
import imgRobusto from "../../assets/images/bydgoszcz/cigar/sizes.jpg";
import imgStrong from "../../assets/images/bydgoszcz/cigar/smoke.jpg";
import imgExperience from "../../assets/images/bydgoszcz/cigar/gb_10.jpg";

export default function JakieCygaroNaPoczatek() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        {/* ARTICLE */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: "Jakie cygaro na początek?",
            description:
              "Poradnik dla początkujących – jakie cygaro wybrać na start, jak je palić i gdzie spróbować.",
            author: {
              "@type": "Organization",
              name: "Whitebull Steakhouse",
            },
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "https://whitebull.com.pl/jakie-cygaro-na-poczatek",
            },
          })}
        </script>

        {/* FAQ */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Jakie cygaro na początek?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Najlepiej wybrać łagodne cygara z Dominikany lub Hondurasu, np. w formacie Robusto.",
                },
              },
              {
                "@type": "Question",
                name: "Czy cygaro jest mocne?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Nie wszystkie – dla początkujących polecane są łagodne cygara o kremowym profilu.",
                },
              },
              {
                "@type": "Question",
                name: "Gdzie spróbować cygara?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Najlepiej w palarni cygar, gdzie można liczyć na odpowiednie warunki i pomoc w wyborze.",
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <div className="bg-black text-white min-h-screen px-4 py-10">
        <FloatingLogoAndButton />
        <div className="mb-20"></div>

        {/* HERO */}
        <section className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Jakie cygaro na początek?
          </h1>
          <p className="text-lg opacity-90">
            Jeśli zaczynasz swoją przygodę z cygarami, wybór pierwszego cygara
            ma ogromne znaczenie. Sprawdź, od czego najlepiej zacząć.
          </p>
        </section>

        {/* BENTO */}
        <section className="max-w-6xl mx-auto mb-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* DUŻY TILE */}
            <div className="md:col-span-2 bg-zinc-900 p-6 rounded-2xl flex flex-col justify-between">
              <div>
                <h2 className="text-2xl font-semibold mb-4">
                  🌿 Najlepsze cygara na start
                </h2>
                <ul className="space-y-2 opacity-90">
                  <li>✔️ łagodne i kremowe profile</li>
                  <li>✔️ format Robusto</li>
                  <li>✔️ dobre spalanie</li>
                </ul>
              </div>

              <img
                src={imgMild}
                alt="łagodne cygaro dla początkujących"
                className="w-full h-64 object-cover mt-4 rounded-xl"
              />
            </div>

            {/* REGIONY */}
            <div className="bg-zinc-900 p-6 rounded-2xl flex flex-col justify-between">
              <div>
                <h3 className="text-xl font-semibold mb-3">🌍 Pochodzenie</h3>
                <p className="opacity-90 text-sm">
                  Dominikana i Honduras to najlepszy wybór na początek.
                </p>
              </div>

              <img
                src={imgOrigin}
                alt="pochodzenie cygar"
                className="w-full h-64 object-cover mt-4 rounded-xl"
              />
            </div>

            {/* ROZMIAR */}
            <div className="bg-zinc-900 p-6 rounded-2xl flex flex-col justify-between">
              <div>
                <h3 className="text-xl font-semibold mb-3">📏 Rozmiar</h3>
                <p className="opacity-90 text-sm">
                  Robusto to najlepszy balans długości i smaku.
                </p>
              </div>

              <img
                src={imgRobusto}
                alt="cygaro robusto"
                className="w-full h-64 object-cover mt-4 rounded-xl"
              />
            </div>

            {/* BŁĘDY */}
            <div className="md:col-span-2 bg-red-900/20 p-6 rounded-2xl flex flex-col justify-between">
              <div>
                <h3 className="text-xl font-semibold mb-3">❌ Czego unikać?</h3>
                <ul className="opacity-90 text-sm space-y-1">
                  <li>bardzo mocnych cygar</li>
                  <li>dużych formatów</li>
                  <li>tanich jakości</li>
                </ul>
              </div>

              <img
                src={imgStrong}
                alt="mocne cygaro"
                className="w-full h-64 object-cover object-top mt-4 rounded-xl"
              />
            </div>

            {/* EXPERIENCE */}
            <div className="bg-zinc-900 p-6 rounded-2xl flex flex-col justify-between md:col-span-3">
              <div>
                <h3 className="text-xl font-semibold mb-3">
                  🍽️ Gdzie spróbować?
                </h3>
                <p className="opacity-90 text-sm">
                  Najlepiej w palarni cygar – klimat robi różnicę.
                </p>
              </div>

              <img
                src={imgExperience}
                alt="cygaro whisky klimat"
                className="w-full h-64 object-cover mt-4 rounded-xl"
              />
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="text-center mb-12">
          <p className="opacity-70 mb-4">
            Nie wiesz co wybrać? Pomożemy dobrać pierwsze cygaro na miejscu.
          </p>

          <a href="/palarnia-cygar-bydgoszcz" className="underline text-lg">
            → Spróbuj cygara w palarni Whitebull w Bydgoszczy
          </a>
        </section>

        {/* LINKI */}
        <section className="text-center space-y-2">
          <a href="/jak-palic-cygaro" className="underline opacity-70 block">
            → Jak palić cygaro
          </a>
          <a href="/rodzaje-cygar" className="underline opacity-70 block">
            → Rodzaje cygar
          </a>
        </section>
      </div>
    </>
  );
}
